<template>
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
    <!-- Logo Icons -->
    <symbol id="icon-logo-dark" viewBox="0 0 120 40">
      <!-- Left angle bracket < -->
      <text x="15" y="28" font-family="monospace" font-size="24" font-weight="bold" fill="#4fd1c5">
        &lt;
      </text>

      <!-- BB text -->
      <text x="38" y="28" font-family="monospace" font-size="24" font-weight="bold" fill="#fbd38d">
        BB
      </text>

      <!-- Closing tag /> -->
      <text x="70" y="28" font-family="monospace" font-size="24" font-weight="bold" fill="#4fd1c5">
        /&gt;
      </text>
    </symbol>

    <symbol id="icon-logo-light" viewBox="0 0 120 40">
      <!-- Left angle bracket < -->
      <text x="15" y="28" font-family="monospace" font-size="24" font-weight="bold" fill="#319795">
        &lt;
      </text>

      <!-- BB text -->
      <text x="38" y="28" font-family="monospace" font-size="24" font-weight="bold" fill="#dd6b20">
        BB
      </text>

      <!-- Closing tag /> -->
      <text x="70" y="28" font-family="monospace" font-size="24" font-weight="bold" fill="#319795">
        /&gt;
      </text>
    </symbol>

    <!-- GitHub Icon -->
    <symbol
      id="icon-github"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
      />
    </symbol>

    <!-- LinkedIn Icon -->
    <symbol
      id="icon-linkedin"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect x="2" y="9" width="4" height="12" />
      <circle cx="4" cy="4" r="2" />
    </symbol>

    <!-- Theme Icons -->
    <symbol
      id="icon-light-mode"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </symbol>

    <symbol
      id="icon-system-theme"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </symbol>

    <symbol
      id="icon-dark-mode"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
      />
    </symbol>

    <!-- Menu Icons -->
    <symbol
      id="icon-menu"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M4 6h16M4 12h16M4 18h16" />
    </symbol>

    <symbol
      id="icon-close"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M6 18L18 6M6 6l12 12" />
    </symbol>

    <!-- Contact Icons -->
    <symbol
      id="icon-location"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </symbol>

    <symbol
      id="icon-phone"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
      />
    </symbol>

    <symbol
      id="icon-email"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </symbol>

    <symbol
      id="icon-link"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
    </symbol>

    <!-- Send Button Icon -->
    <symbol
      id="icon-arrow-up"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 19V5M5 12l7-7 7 7" />
    </symbol>
  </svg>
</template>
